export enum LANGUAGE {
  RU = 'RU',
  EN = 'EN',
}
